import { demoAdminAccess } from "./demo-admin";

export const isAccessGranted = (path: string, role: string) => {
    if (role === "demo-admin") {
        let a = demoAdminAccess.includes(path);
        return a;
    }
    return false;
};
